import { t } from 'i18next';

export const VIEW_MODE_META = {
  compact: {
    key: 'compact',
    label: t('flexMatch.compactView'),
    icon: 'arrow-down-left-and-arrow-up-right-to-center'
  },
  detailed: {
    key: 'detailed',
    label: t('flexMatch.detailedView'),
    icon: 'arrow-up-right-and-arrow-down-left-from-center'
  }
} as const;

export const FORM_DEFAULT_VALUES = {
  costCenter: null,
  employee: null,
  rosterFunction: null,
  reason: null,
  cluster: null,
  pool: null,
  agency: null,
  preference: null,
  status: null
};
